import type { BenefitSelectionCoverage } from '@/features/quotes/types/group-life/coverage-schema.types';
import type { CoverageSelection } from '@/features/quotes/utils/group-life/coverage-resolver';
import {
  benefitOptionLabel,
  benefitSumInsured,
} from '@/features/quotes/utils/group-life/benefit-sum-insured.util';
import { formatCurrencyBRL } from '@/features/quotes/utils/group-life/format';
import { CoverageRowShell, SelectControl } from './coverage-row-shell';

type Props = {
  coverage: BenefitSelectionCoverage;
  selection: CoverageSelection | undefined;
  onChange: (next: CoverageSelection) => void;
  disabled?: boolean;
  error?: string;
};

export function BenefitSelectionRow({
  coverage,
  selection,
  onChange,
  disabled,
  error,
}: Props) {
  const enabled =
    selection?.kind === 'BENEFIT_SELECTION' ? selection.enabled : false;
  const selectedChildCode =
    selection?.kind === 'BENEFIT_SELECTION'
      ? selection.selectedChildCoverageCode
      : null;

  // A IS do benefício está em `DefaultSI` — ver `benefitSumInsured`. Lendo só
  // `sumInsured`, a opção aparecia sem o valor ao lado do nome.
  const options = coverage.children.map(child => ({
    value: child.code,
    label: benefitOptionLabel(
      child.name,
      benefitSumInsured(child),
      formatCurrencyBRL
    ),
  }));

  return (
    <CoverageRowShell
      name={coverage.name}
      description={coverage.description}
      badge={coverage.isRider ? 'Adicional' : undefined}
      enabled={enabled}
      onToggle={next =>
        onChange({
          kind: 'BENEFIT_SELECTION',
          enabled: next,
          selectedChildCoverageCode: selectedChildCode,
        })
      }
      disabled={disabled}
      error={error}
      control={
        <SelectControl
          value={selectedChildCode ?? ''}
          onChange={value =>
            onChange({
              kind: 'BENEFIT_SELECTION',
              enabled,
              selectedChildCoverageCode: value || null,
            })
          }
          options={options}
          disabled={disabled || !enabled}
          placeholder='Selecione uma opção'
        />
      }
    />
  );
}
